import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../components/Carousel.css';
import logoImage from '../assets/logo.jpg';
import slide1 from '../assets/slide-1.png';
import slide2 from '../assets/slide-2.png';
import slide3 from '../assets/slide-3.jpg';
import martelli_img from '../assets/Maurizio_Martelli.JPG';
import breccia_img from '../assets/Massimo_Breccia.png';
import barberi_img from '../assets/Walter_Barberi.jpg';
import montanari_img from '../assets/Marta_Montanari.jpg';
import palumbo_img from '../assets/Giovanna_Palumbo.png';
import CV_Maurizio_Martelli from '../assets/CV_Maurizio_Martelli.pdf';
import CV_Massimo_Breccia from '../assets/CV_Massimo_Breccia.pdf';
import CV_Walter_Barberi from '../assets/CV_Walter_Barberi.docx';
import CV_Giovanna_Palumbo from '../assets/CV_Giovanna_Palumbo.pdf';
const PreloadImages = ({ images, onLoad }) => {
  useEffect(() => {
    let loadedImages = 0;
    const imagePromises = images.map(src => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          loadedImages++;
          if (loadedImages === images.length) {
            onLoad();
          }
          resolve();
        };
        img.onerror = reject;
      });
    });

    Promise.all(imagePromises)
      .catch(error => {
        console.error('Error preloading images:', error);
        onLoad(); // Show content even if some images fail to load
      });
  }, [images, onLoad]);

  return null;
};

const Home = () => {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const carouselImages = [slide1, slide2, slide3];
  const handleDownloadCV = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Maurizio_Martelli;
    link.download = 'CV_Maurizio_Martelli.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadCV2 = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Massimo_Breccia;
    link.download = 'CV_Massimo_Breccia.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadCV3 = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Walter_Barberi;
    link.download = 'CV_Walter_Barberi.docx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadCV4 = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Giovanna_Palumbo;
    link.download = 'CV_Giovanna_Palumbo.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="bg-white overflow-hidden">
      {/* Hero Section with improved background color and animation effects */}
      <PreloadImages 
        images={carouselImages} 
        onLoad={() => setImagesLoaded(true)} 
      />
      <section className="relative text-white overflow-hidden w-full flex justify-center">
        {!imagesLoaded ? (
          <div className="w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px] bg-gray-200 animate-pulse flex items-center justify-center">
            <div className="text-gray-400">Loading...</div>
          </div>
        ) : (
        <Slider
          dots={true}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          autoplay={true}
          autoplaySpeed={6000}
          arrows={false}
          className="carousel-slider w-full"
          responsive={[
            {
              breakpoint: 768,
              settings: {
                arrows: false
              }
            }
          ]}
        >
          {/* Slide 1 */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px]">
            <div className="absolute inset-0">
              <img 
                src={slide1} 
                alt="Robin Hood Roma" 
                className="w-full h-full object-cover object-center"
              />
            </div>
            
          </div>
          
          {/* Slide 2 */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px]">
            <div className="absolute inset-0">
              <img 
                src={slide2} 
                alt="Robin Hood Roma" 
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
          
          {/* Slide 3 */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px]">
            <div className="absolute inset-0">
              <img 
                src={slide3} 
                alt="Robin Hood Roma" 
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="w-full py-8 md:py-16 lg:py-20 relative z-10 h-full flex items-center justify-center">
              <div className="max-w-3xl transform transition-all duration-700 translate-y-0 opacity-100 bg-black/40 p-4 sm:p-6 md:p-8 rounded-lg" style={{animation: 'fadeInUp 0.8s ease-out'}}>
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-3 md:mb-6 leading-tight">
                  <span className="inline-block hover:scale-105 transition-transform duration-300">Robin Hood Roma ODV</span>
                </h1>
                <p className="text-lg sm:text-xl md:text-2xl mb-4 md:mb-10 leading-relaxed text-center" style={{ fontFamily: 'Bradley Hand ITC, cursive' }}>...dai pazienti per i pazienti...</p>
                <div className="flex flex-wrap gap-2 md:gap-4 justify-center">
                  <Link to="/sostienici" className="group px-4 sm:px-5 md:px-7 py-2 sm:py-3 md:py-4 bg-accent hover:bg-accent/90 text-white font-bold rounded-lg shadow-lg hover:shadow-accent/30 hover:-translate-y-1 transition-all duration-300 flex items-center space-x-2">
                    <span>Sostienici</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </Link>
                  <Link to="/chi-siamo" className="px-4 sm:px-5 md:px-7 py-2 sm:py-3 md:py-4 bg-transparent hover:bg-white/20 border-2 border-white text-white font-bold rounded-lg hover:-translate-y-1 transition-all duration-300">
                    Scopri di più
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Slider>
        )}
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-12 items-center">
            <div className="md:w-1/2 transform transition-all duration-500 hover:scale-[1.02]" data-aos="fade-right">
              <div className="relative rounded-xl overflow-hidden shadow-2xl">
                <img 
                  src={logoImage} 
                  alt="Volontari di Robin Hood Roma ODV" 
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-[#2E7D32]/80 to-transparent opacity-70 mix-blend-multiply"></div>
                <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-[#2E7D32] to-transparent opacity-40"></div>
                <div className="absolute -bottom-1 -right-1 w-20 h-20 bg-accent rounded-full blur-2xl opacity-60"></div> */}
              </div>
            </div>
            <div className="md:w-1/2" data-aos="fade-left" data-aos-delay="200">
              <h2 className="text-3xl font-bold text-primary mb-6 flex items-center">
                <span className="border-b-4 border-accent pb-2">Chi Siamo</span>
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                L'<b>Associazione Robin Hood Roma ODV</b> è un'organizzazione di volontariato costituita da genitori e da pazienti con malattie ematologiche rare, 
                seguiti presso l'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma.
              </p>
              <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                L'utilità sociale e la solidarietà sono la base sui quali si è costituita l'Associazione, il cui scopo è garantire a tutti i malati 
                ‒ bambini, adolescenti e adulti ‒ di poter usufruire dell'assistenza di cui hanno bisogno. L'idea "che nessun paziente abbia di meno" 
                anima lo spirito dei volontari, dei soci e di tutti coloro che operano in questa Associazione.
              </p>
              <Link to="/chi-siamo" className="group px-6 py-3 bg-primary hover:bg-primary/90 text-white font-bold rounded-lg shadow-md hover:shadow-lg inline-flex items-center space-x-2 hover:-translate-y-1 transition-all duration-300">
                <span>La nostra <i>Mission</i></span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Storia Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-10">La Nostra Storia</h2>
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-primary hover:shadow-lg transition duration-300">
                <h3 className="text-xl font-bold text-primary mb-3">La fondazione - 2004</h3>
                <p className="text-gray-600 mb-4">
                  L'<b>Associazione Robin Hood Roma Onlus</b> nasce l'8 luglio 2004, per volontà di genitori dei bambini e degli adolescenti, 
                  seguiti presso l'Ematologia Pediatrica dell'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma.
                </p>
                <p className="text-gray-600">
                  Dalla sua fondazione fino all'ottobre 2022, l'Associazione ha aiutato economicamente famiglie di pazienti in difficoltà; 
                  ha acquistato presidi medicali e supportato il personale medico e infermieristico nei corsi di formazione.
                </p>
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-primary hover:shadow-lg transition duration-300">
                <h3 className="text-xl font-bold text-primary mb-3">La trasformazione - 2022</h3>
                <p className="text-gray-600 mb-4">
                  Nell'ottobre 2022, con la chiusura del reparto pediatrico, è stato deciso di proseguire l'attività dell'Associazione 
                  focalizzando l'attenzione nel supportare i pazienti con patologie rare ematologiche di qualsiasi età.
                </p>
                <p className="text-gray-600">
                  Trasmigrata nel RUNTS nel novembre 2022, l'<b>Associazione Robin Hood Roma ODV</b> è diventata, nel marzo 2024, 
                  una ODV, con un nuovo statuto ed ha acquisito personalità giuridica.
                </p>
              </div>
            </div>
            
            <div className="mt-8 bg-white rounded-lg shadow-md p-6 border-t-4 border-primary hover:shadow-lg transition duration-300">
              <h3 className="text-xl font-bold text-primary mb-3">Oggi</h3>
              <p className="text-gray-600">
                Dal 2022 a oggi, l'Associazione ha continuato a sostenere economicamente e a migliorare l'assistenza ai pazienti 
                con malattie rare seguiti in Ematologia: con l'acquisto di dispositivi medici (come elettrocardiografi, reagenti, etc); 
                a supportare medici e infermieri per migliorare la loro professionalità in ambiti specifici (trapianto di cellule 
                staminali e terapie innovative, etc).
              </p>
            </div>
            
            <div className="mt-8 text-center">
              <Link to="/chi-siamo" className="inline-flex items-center px-6 py-3 bg-primary text-white font-bold rounded-lg shadow-md hover:bg-primary/90 transition-colors">
                Scopri la storia completa
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Programs Highlights */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">La Nostra <i>Mission</i></h2>
          
          <p className="text-gray-700 text-lg text-center mb-10 max-w-4xl mx-auto">
            L'Associazione, riconosciuta operante all'interno dell'AOU Policlinico Umberto I, vuole continuare nell'impegno a sostegno 
            di genitori e pazienti con patologie rare ematologiche, in armonia con gli operatori e le altre associazioni con cui collabora 
            e/o che operano nella stessa struttura. Gli obiettivi sono molteplici:
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Supporto Economico</h3>
              <p className="text-gray-600 mb-4">
                Supportare economicamente le necessità diagnostiche e/o terapeutiche di pazienti in difficoltà economiche.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Accesso ai Servizi</h3>
              <p className="text-gray-600 mb-4">
                Facilitare l'accesso ai servizi sulle malattie rare che operano in Ematologia, con un sito internet fruibile ed aggiornato, strutturato anche per favorire e promuovere la diffusione della conoscenza delle patologie rare di interesse ematologico.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Promozione Rapporti</h3>
              <p className="text-gray-600 mb-4">
                Stimolare e promuove i rapporti tra il personale medico, infermieristico, le famiglie e gli altri operatori del settore.
              </p>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Ricerca Scientifica</h3>
              <p className="text-gray-600 mb-4">
                Favorire la ricerca nel campo delle malattie ematologiche rare, promuovendo studi e ricerche sulle patologie rare di interesse ematologico e continuando a supportare infermieri e medici per convegni, riunioni e corsi di aggiornamento.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Collaborazione</h3>
              <p className="text-gray-600 mb-4">
                Incoraggiare i rapporti di collaborazione tra centri, adulti e pediatrici, nazionali e internazionali, nonché organizzazioni ed enti che perseguono scopi analoghi.
              </p>
            </div>



            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Supporto Psicologico</h3>
              <p className="text-gray-600 mb-4">
              Assicurare un supporto ricreativo e terapie di sostegno mirate al benessere dei pazienti, bambini e adulti, dei familiari e degli operatori della struttura.
              </p>
            </div>
            
                
            </div>
            </div>
          
      </section>
      
      {/* 5 x mille - Sezione dedicata */}
      <section className="py-20 bg-gradient-to-b from-blue-50 via-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-6">
            <div className="h-0.5 w-16 bg-gradient-to-r from-transparent to-green-700 mr-4"></div>
            <h2 className="text-3xl font-bold text-green-800 relative">
              Sostieni la nostra <i>Mission</i>
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-500"></span>
            </h2>
            <div className="h-0.5 w-16 bg-gradient-to-l from-transparent to-green-700 ml-4"></div>
          </div>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12 text-lg">
            Il tuo contributo è fondamentale per permetterci di continuare il nostro lavoro.
          </p>
          
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 group transition-all duration-300 hover:shadow-xl">
              <div className="bg-gradient-to-r from-green-700 to-green-800 py-5 px-8 text-white flex items-center justify-between relative overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-yellow-300 opacity-20 rounded-full transform -translate-y-20 translate-x-16 group-hover:translate-x-10 transition-transform duration-500"></div>
                <div className="flex items-center">
                  <span className="text-2xl font-bold mr-2">5</span>
                  <span className="text-xl font-semibold">x mille</span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-300 z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="p-8 md:p-10">
                <h3 className="text-2xl md:text-3xl font-bold text-green-800 mb-4 flex items-center">
                  <span className="mr-3">Sostienici con il tuo 5 x mille</span>
                  <div className="h-px flex-grow bg-gradient-to-r from-green-700 to-transparent opacity-30"></div>
                </h3>
                <p className="text-gray-700 mb-8 text-lg leading-relaxed">
                  Destinando all'<b>Associazione Robin Hood Roma ODV</b> il 5 x mille, contribuisci, senza alcun aggravio delle imposte,
                  a realizzare gli obiettivi dell'associazione. È un gesto di solidarietà, che può contribuire a migliorare la vita dei pazienti.
                </p>
                
                <div className="mb-10 py-6 px-8 bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-lg text-center border-l-4 border-yellow-500 shadow-sm transform hover:scale-[1.01] transition-transform">
                  <div className="text-sm uppercase tracking-wide text-green-800 font-medium mb-1">Codice Fiscale</div>
                  <div className="font-mono font-bold text-2xl md:text-3xl tracking-wider text-green-900 flex items-center justify-center space-x-1">
                    <span className="bg-white px-2 py-1 rounded shadow-sm">97353740588</span>
                  </div>
                </div>
                
                <div className="text-center">
                  <a href="/sostienici" className="inline-flex items-center justify-center px-8 py-4 bg-green-700 text-white font-bold rounded-lg shadow-md hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg group">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Come donare</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* I Nostri Eventi */}
      <section className="py-20 bg-gradient-to-b from-green-50 to-white">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-6">
            <div className="h-0.5 w-16 bg-gradient-to-r from-transparent to-green-700 mr-4"></div>
            <h2 className="text-3xl font-bold text-green-800 relative">
              I Nostri Eventi
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-500"></span>
            </h2>
            <div className="h-0.5 w-16 bg-gradient-to-l from-transparent to-green-700 ml-4"></div>
          </div>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12 text-xl">
            Partecipa ai nostri eventi per conoscere il volto dell'Associazione, le nostre idee e la nostra Comunità.
          </p>
          
          <div className="text-center">
            <Link to="/eventi" className="inline-flex items-center px-5 py-3 bg-green-700 text-white font-semibold rounded-md hover:bg-green-800 transition-all duration-300 shadow-sm hover:shadow-md mt-4">
                      <span className="text-lg">Scopri di più</span>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
            </Link>
          </div>
        </div>
      </section>


      {/* Call to Action */}
      <section className="py-16 bg-green-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Unisciti alla nostra <i>Mission</i></h2>
          <div className="text-xl mb-8 max-w-3xl mx-auto">
            <p>Puoi aiutarci a fare di più per le persone con malattie rare ematologiche per le quali ci impegniamo ogni giorno:</p>
            <div className="my-4 font-bold text-2xl">DONA!</div>
            <p>Un contributo minimo può fare la differenza.</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/sostienici" className="px-8 py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-md transition duration-300">
              Dona ora
            </Link>
            <Link to="/volontari" className="px-8 py-4 bg-transparent hover:bg-white/20 border-2 border-white text-white font-bold rounded-md transition duration-300">
              Diventa volontario
            </Link>
            <Link to="/soci"  className="px-8 py-4 bg-red-500 hover:bg-red-600 text-white font-bold rounded-md transition duration-300">
              Diventa socio
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

